import { groupBy, get, merge } from 'lodash';
import { DISCOVERY_LIST_TYPES } from '../../constants';

import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../utils/redux';

const paginationInitialState = {
  global: {
    offset: 0,
    limit: 4,
  },
  organization: {
    offset: 0,
    limit: 4,
  },
};

const initialState = {
  ...requestInitialState,
  pagination: paginationInitialState,
};

const request = {
  endpoint: 'communities',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
    {
      type: 'payload.query',
      queryParameter: 'type',
      selector: 'type',
    },
  ],
};

export const consts = createReqConsts('communities', 'reqDiscoverCommunities', [
  'UPDATE_COMMUNITY',
]);
export const paginatedConsts = createReqConsts(
  'communities',
  'reqPaginatedDiscoverCommunities',
  ['LOAD_NEXT_COMMUNITIES', 'UPDATE_PAGINATION_PARAMETERS'],
);

export const actions = createActions(consts);
export const paginatedActions = createActions(paginatedConsts);

export const watcher = createReqWatcher(consts, actions, request);

export const paginatedWatcher = createReqWatcher(
  paginatedConsts,
  paginatedActions,
  request,
);

const defaultRequestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { payload } = action;

  switch (action.type) {
    case consts.SUCCEED: {
      return Object.assign(
        {},
        state,
        requestInitialState,
        {
          succeed: true,
        },
        groupBy(payload, 'accessScope'),
      );
    }
    case consts.UPDATE_COMMUNITY: {
      const { id, accessScope } = action.payload;
      const prevCommunitiesList = get(state, accessScope, []);
      const updatedCommunitiesList = prevCommunitiesList.map(community => {
        if (id === community.id) {
          return payload;
        }
        return community;
      });
      return Object.assign(
        {},
        state,
        requestInitialState,
        {
          succeed: true,
        },
        {
          [accessScope]: updatedCommunitiesList,
        },
      );
    }
    case paginatedConsts.SUCCEED: {
      const { global = [], organization = [] } = groupBy(
        payload,
        'accessScope',
      );

      const prevGlobal = get(state, [DISCOVERY_LIST_TYPES.GLOBAL], []);
      const prevOrganization = get(
        state,
        [DISCOVERY_LIST_TYPES.ORGANIZATION],
        [],
      );

      return Object.assign({}, state, requestInitialState, {
        succeed: true,
        global: prevGlobal.concat(global),
        organization: prevOrganization.concat(organization),
      });
    }
    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS: {
      const { type, offset, limit } = payload;

      return merge({}, state, {
        pagination: {
          [type]: { offset, limit },
        },
      });
    }
    default: {
      return defaultRequestReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/reqDiscoverCommunities.js